import { render, staticRenderFns } from "./BanksList.vue?vue&type=template&id=710ff9e6&scoped=true&"
import script from "./BanksList.vue?vue&type=script&lang=js&"
export * from "./BanksList.vue?vue&type=script&lang=js&"
import style0 from "./BanksList.vue?vue&type=style&index=0&id=710ff9e6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710ff9e6",
  null
  
)

export default component.exports